import { render, staticRenderFns } from "./StoreRouterView.vue?vue&type=template&id=2870be84&"
import script from "./StoreRouterView.vue?vue&type=script&lang=js&"
export * from "./StoreRouterView.vue?vue&type=script&lang=js&"
import style0 from "./StoreRouterView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports